exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error {\r\n    margin: 10px;\r\n    padding: 10px;\r\n    background-color: #ea7373;\r\n    border: 1px;\r\n    border-color: red;\r\n    border-radius: 2px;\r\n    color: #fff;\r\n}\r\n\r\nul {\r\n    margin: 0px;\r\n    padding: 0 0 0 20px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/app/shared/validation-message.component.css
// module id = 2317
// module chunks = 1